import {PopoverInstance} from "./PopoverInstance";
import {IPopoverOptions} from "./IPopoverOptions";

export abstract class PopoverRenderer {
    abstract render<T>(options: IPopoverOptions): PopoverInstance<T>;

}
